/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Role_Bound_BuyerInputs */

const cs_clients_role_bound_buyer = /** @type {(inputs: Clients_Role_Bound_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávky: kritéria koupě, rozpočet, dispozice, lokalita, stav financování u každé poptávky.`)
};

const en_clients_role_bound_buyer = /** @type {(inputs: Clients_Role_Bound_BuyerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demands: purchase criteria, budget, layout, locality, financing status on each demand.`)
};

/**
* | output |
* | --- |
* | "Demands: purchase criteria, budget, layout, locality, financing status on each demand." |
*
* @param {Clients_Role_Bound_BuyerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_role_bound_buyer = /** @type {((inputs?: Clients_Role_Bound_BuyerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Role_Bound_BuyerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_role_bound_buyer(inputs)
	return cs_clients_role_bound_buyer(inputs)
});